"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalRegistry = void 0;
const eventBus_1 = __importDefault(require("../common/eventBus"));
const events_1 = require("../common/events");
class ModalRegistry {
    static registry;
    modals = new Map();
    static get() {
        if (!this.registry)
            this.registry = new ModalRegistry();
        return this.registry;
    }
    register = (modal, props) => {
        this.modals.set(modal, props);
    };
    show = (modal, customProps) => {
        const modalProps = this.modals.get(modal);
        const { props: compProps, ...modalPropsCustom } = customProps || {};
        eventBus_1.default.bus.emit(events_1.Events.OPEN_MODAL, modal, {
            ...modalProps,
            ...modalPropsCustom,
            props: compProps,
        });
    };
    showAsync = (modal, customProps) => {
        const modalProps = this.modals.get(modal);
        const { props: compProps, ...modalPropsCustom } = customProps || {};
        eventBus_1.default.bus.emit(events_1.Events.OPEN_MODAL, modal, {
            ...modalProps,
            ...modalPropsCustom,
            props: compProps,
        });
        return new Promise((resolve) => {
            eventBus_1.default.bus.once(events_1.Events.CLOSE_MODAL, resolve);
        });
    };
    close = (modal) => {
        eventBus_1.default.bus.emit(events_1.Events.CLOSE_MODAL, modal);
    };
}
exports.ModalRegistry = ModalRegistry;
